import React from 'react';
import { useMutation, gql } from '@apollo/client';
import ForgotPassword from './ForgotPassword';

const REQUEST_PASSWORD_RESET = gql`
  mutation requestPasswordReset($username: String!) {
    requestPasswordReset(username: $username)
  }
`;

const PASSWORD_RESET = gql`
  mutation resetPassword($resetPasswordAttributes: ResetPasswordAttributes!) {
    resetPassword(resetPasswordAttributes: $resetPasswordAttributes)
  }
`;

const ForgotPasswordData = (props) => {
  const [resetPassword] = useMutation(PASSWORD_RESET);
  const [requestPasswordReset] = useMutation(REQUEST_PASSWORD_RESET);
  return (
    <ForgotPassword
      resetPassword={resetPassword}
      requestPasswordReset={requestPasswordReset}
      {...props}
    />
  );
};

export default ForgotPasswordData;
